export default __webpack_public_path__ + "static/media/finishicon-selected.4d340f89.svg";